<template>
  <div v-if="!loading">
    <keep-alive>
      <router-view :key="key" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
    <van-tabbar
      v-if="this.arr.findIndex(item => item == this.$route.path) != -1"
      @change="change"
      :placeholder="true"
      :safe-area-inset-bottom="true"
      :value="active"
      active-color="#43CF7C"
      inactive-color="#A6A6A6"
    >
      <van-tabbar-item>
        <span>看一尘网</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('../../assets/img/indexIconac.png')
                : require('../../assets/img/indexIcon.png')
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>一尘盯盘</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('../../assets/img/ycdpIconac.png')
                : require('../../assets/img/ycdpIcon.png')
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>手机发帖</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('../../assets/img/ftIconac.png')
                : require('../../assets/img/ftIcon.png')
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>个人中心</span>
        <template #icon="props">
          <img
            :src="
              props.active
                ? require('../../assets/img/userBarIconac.png')
                : require('../../assets/img/userBarIcon.png')
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <van-popup
      safe-area-inset-bottom
      style="background:transparent;margin-top:-80px"
      v-model="show"
    >
      <div :class="isActivity ? 'vip15day' : ''" class="vipimgbox">
        <img v-if="isActivity" style="width:330px" src="@/assets/img/vip1.png" alt="" />
        <img v-else-if="vipPost" style="width:330px" src="@/assets/img/vipPost.png" alt="" />
        <img v-else style="width:330px" src="@/assets/img/vip3days.png" alt="" />
        <div @click.stop="backvip" class="btn"></div>
        <div @click.stop="show = false" class="close"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import axios from 'axios';
import { wxuser, getFreeVip, getFreeFTVip, getActivityVip, yichenLoginEx } from '@/api/base';
import { formatDateTimeRT, getParamsLogin, setFormateDateEnd } from '@/utils/index';
export default {
  metaInfo() {
    return {
      meta: this.metaData,
    };
  },
  data() {
    return {
      loading: false,
      arr: ['/plate', '/index', '/user', '/plate/list', '/createPost/list'],
      include: [],
      show: false,
      metaData: [
        {
          name: 'viewport',
          content:
            'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0',
        },
      ],
      isActivity: this.$store.state.app.isActivity,
      vipPost: false,
    };
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
    active() {
      let a = 0;
      switch (this.$route.path) {
        case '/plate':
          a = 0;
          break;
        case '/index':
          a = 1;
          break;
        case '/createPost/list':
          a = 2;
          break;
        case '/user':
          a = 3;
          break;
        default:
          a = 0;
          break;
      }
      return a;
    },
  },
  watch: {
    $route(to, from) {
      // 如果要to(进入)的页面是需要keepAlive缓存的，把name push进include数组中
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
        from.meta.scrollHeight = document.documentElement.scrollTop;
      }
      // 如果 要 form(离开) 的页面是 keepAlive缓存的，
      // 再根据 deepth 来判断是前进还是后退
      // 如果是后退：
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        const index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
        document.documentElement.scrollTop = to.meta.scrollHeight;
      }
      if (to.name == 'posts') {
        this.metaData = [
          {
            name: 'viewport',
            content: 'width=device-width,height=device-height, viewport-fit=cover',
          },
        ];
      } else {
        this.metaData = [
          {
            name: 'viewport',
            content:
              'width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0',
          },
        ];
      }
    },
  },
  beforeCreate() {
    // this.getAdBanner();
    axios.get('/ad/ad.json').then(response => {
      // this.adData = response.data.list;
      this.$store.commit('setAdBanner', response.data);
    });
  },
  created() {
    this.$route.path != '/posts' && this.getUserinfo();
  },
  methods: {
    async getAdBanner() {
      //获取banner 广告位
    },
    change(e) {
      switch (e) {
        case 0:
          this.$router.push('/plate');
          break;
        case 1:
          this.$router.push('/index');
          break;
        case 2:
          this.$router.push('/createPost/list');
          break;
        case 3:
          this.$router.push('/user');
          break;
        default:
          break;
      }
      this.isDialogShow();
    },
    getUserinfo() {
      this.loading = true;
      let that = this;
      wxuser().then(res => {
        res.data.wxUser.isVip = 0;
        let now = new Date().getTime() / 1000;
        res.data.vipInfos.map(item => {
          if (item.vipType == 1 && now < new Date(item.validityTime).getTime() / 1000) {
            res.data.wxUser.isVip = 1;
            res.data.wxUser.vipExpireTime = setFormateDateEnd(item.validityTime);
          }
        });
        this.userinfo = res.data.wxUser;
        this.loading = false;
        this.$store.commit('setUserinfo', res.data.wxUser);
        // window.localStorage.setItem('userInfo', JSON.stringify(this.userinfo));
        // if (res.data.isReceive == 0) {
        //   this.show = true;
        // }
        this.isDialogShow();
        // this.$dialog
        //   .confirm({
        //     title: '恭喜！您可领取盯盘会员7天',
        //     message:
        //       '<div>立享会员六大权益</div><div style="text-align: left;color: #333;line-height: 35px;padding-left: 15%;"><p>1.一尘新帖盯盘</p><p>2.一尘成交帖提醒</p><p>3.一尘会员发帖提醒</p><p>4.一尘会员帖成交提醒</p><p>5.一尘帖子特别关注</p><p>6.钱币配号系统</p></div>',
        //     confirmButtonText: '立即领取',
        //     cancelButtonText: '开通会员',
        //   })
        //   .then(() => {
        //     // on confirm
        //   })
        //   .catch(() => {
        //     // on cancel
        //   });

        let ycUserinfos = JSON.parse(window.localStorage.getItem('ycUserinfos'));
        if (ycUserinfos && ycUserinfos.userName) {
          yichenLoginEx(ycUserinfos).then(res => {
            ycUserinfos.grade = res.data.grade;
            window.localStorage.setItem('ycUserinfos', JSON.stringify(ycUserinfos));
          });
        }
      });
    },
    isDialogShow() {
      this.vipPost = this.$route.path == '/createPost/list';
      if (
        (!this.vipPost && this.userinfo.isReceive == 0) ||
        (this.vipPost && this.userinfo.isReceiveFt == 0)
      ) {
        this.show = true;
      }
    },
    backvip() {
      // let fetch = this.isActivity ? getActivityVip : getFreeVip;
      let fetch = this.vipPost ? getFreeFTVip : getFreeVip;
      fetch().then(res => {
        this.getUserinfo();
        this.$toast('恭喜您领取成功！');
        this.show = false;
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.vipimgbox {
  position: relative;
  width: 330px;
}
.vipimgbox img {
  display: block;
  width: 100%;
  height: auto;
}
.vipimgbox .btn {
  width: 200px;
  height: 40px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
}
.vipimgbox .close {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 0;
  left: 53%;
  transform: translateX(-50%);
}
.vip15day .btn {
  bottom: 72px;
}
.vip15day .close {
  bottom: 28px;
}
</style>
